import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';

import { Page } from 'api/contentful/contentTypes.cloverdotcom';
import { FlatEntry } from 'services/cms/flattenContentful';

export function sortPagesBySlug(data: FlatEntry<Page>[]) {
  return reverse(sortBy(data, page => page.slug));
}
